import { render, staticRenderFns } from "./FlowFooter.vue?vue&type=template&id=12ba376f&scoped=true"
import script from "./FlowFooter.vue?vue&type=script&lang=js"
export * from "./FlowFooter.vue?vue&type=script&lang=js"
import style0 from "./FlowFooter.vue?vue&type=style&index=0&id=12ba376f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba376f",
  null
  
)

export default component.exports